/**
 * @generated SignedSource<<69073fa48927541b6ce8d79007a3bdb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTimelineViewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineMultipleViewer">;
  readonly " $fragmentType": "IssueTimelineViewer";
};
export type IssueTimelineViewer$key = {
  readonly " $data"?: IssueTimelineViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTimelineViewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueTimelineMultipleViewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4b7688ad5ebf463f2d3fa2653fcd8df7";

export default node;
